export function getFetchBase() {
  const base = process.env['API_URL'];

  if (!base) {
    throw new Error('API_URL environment variable not set');
  }

  return base;
}
